import { render, staticRenderFns } from "./presClaves.vue?vue&type=template&id=27bc7880"
import script from "./presClaves.vue?vue&type=script&lang=js"
export * from "./presClaves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports